import script from "./FailTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./FailTable.vue?vue&type=script&lang=ts&setup=true"

export default script